import { createAction, createRequestActions } from "common/helpers/action";

export const initUsersList = createRequestActions("USERS.LIST.INIT");
export const showInfoUsersList = createAction("USERS.LIST.SHOW_INFO");
export const updateAccessUserList = createRequestActions("USERS.LIST.UPD_ACCESS");
export const deleteUserUserList = createRequestActions("USERS.LIST.DELETE_USER");
